import React from "react";

function AuthLayout({ children }) {
  return <>{children}</>;
}

export default AuthLayout;
